import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useClaimTypeReducer = () =>
  useSelector((state: ApplicationState) => state.claimType);

